import { BaasicPlatform } from 'baasic-sdk-reactjs';
import baasicOptions from './baasicOptions';

const platform = new BaasicPlatform(baasicOptions);

export default platform;
